import { CategorizedError } from "@modules/error/classes";
import { StorageErrorTypes } from "@shared/models/error.interface";

export class StorageError<T = void> extends CategorizedError<T> {
  constructor(public override title: StorageErrorTypes, public override description: string, public override data?: T) {
    super(title as string, description, data);
  }

  handle<T>(shouldNotify: boolean = false): void {
    const errorLogString = `[${this.title}] ${this.description}: ${JSON.stringify(this.data)}`;
    console.error(errorLogString);
  }

}